import { SxProps, Theme } from '@mui/material'

export const dateSx: SxProps<Theme> = {
  color: (theme) => theme.palette.text.secondary,
  opacity: 0.5,
}
